/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsMagnifyingGlass: {
  name: 'magnifying-glass';
  data: string;
} = {
  name: 'magnifying-glass',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 7a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0ZM7 .5a6.5 6.5 0 1 0 4.23 11.436l3.416 3.418a.5.5 0 0 0 .708-.708l-3.418-3.417A6.5 6.5 0 0 0 7 .5Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
